'use strict';

import angular from 'angular';

function MemFeeResource($resource) {
  return $resource('/api/groups/:groupId/memberfees/:id/:controller', {
    id: '@id'
  }, {
    getDefinedFor: {
      method: 'GET',
      isArray: true
    },
    create: {
      method: 'POST'
    },
    update: { method: 'PUT' }
  });
}

MemFeeResource.$inject = ['$resource'];

export default angular.module('georgeApp.memFeeSvc', [])
  .factory('MemFeeSvc', MemFeeResource)
  .name;
